// TODO: This should eventually move over into features/rolodex
export const PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT =
  'cantilever:component-artifacts:edit'
export const PERMISSION_CANTILEVER_MARKUP_LAYER_EDIT =
  'cantilever:markup-layer:edit'
export const PERMISSION_GECKO_READ = 'gecko:read'
export const PERMISSION_GECKO_INTERNAL_MEMBER = 'gecko:internal:member'
export const PERMISSION_CANTILEVER_PUBLISHER_ARCHIVE_EDITOR =
  'cantilever:publisher-archive:editor'
export const PERMISSION_CANTILEVER_ACCESS_ADMIN = 'cantilever:access:admin'
export const PERMISSION_CANTILEVER_CORE_EDIT = 'cantilever:core:edit'
export const PERMISSION_CANTILEVER_CORE_ADMIN = 'cantilever:core:admin'
export const PERMISSION_CANTILEVER_ASSET_OVERVIEW_VIEWER =
  'cantilever:asset-overview:viewer'
export const PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR =
  'cantilever:asset-overview:editor'
export const PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN =
  'cantilever:asset-overview:admin'
export const PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_VIEWER =
  'cantilever:inspection-overview:viewer'
export const PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_EDITOR =
  'cantilever:inspection-overview:editor'
export const PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_ADMIN =
  'cantilever:inspection-overview:admin'
export const PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_VIEWER =
  'cantilever:inventory-management:viewer'
export const PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_EDITOR =
  'cantilever:inventory-management:editor'
export const PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_ADMIN =
  'cantilever:inventory-management:admin'
export const PERMISSION_CANTILEVER_HEALTH_PLAN_EDITOR =
  'cantilever:health-plan:editor'
export const PERMISSION_CANTILEVER_HEALTH_PLAN_VIEWER =
  'cantilever:health-plan:viewer'
export const PERMISSION_CANTILEVER_EXPLOERER_EDITOR =
  'cantilever:explorer:editor'
export const PERMISSION_CANTILEVER_EXPLOERER_VIEWER =
  'cantilever:explorer:viewer'
export const PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_EDITOR =
  'cantilever:inspection-scheduling:editor'
export const PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_VIEWER =
  'cantilever:inspection-scheduling:viewer'
export const PERMISSION_CANTILEVER_PARTS_THREAD_EDITOR =
  'cantilever:parts-thread:editor'
export const PERMISSION_CANTILEVER_PARTS_THREAD_VIEWER =
  'cantilever:parts-thread:viewer'
export const PERMISSION_CANTILEVER_PHOTOGRAMMETRY_EDITOR =
  'cantilever:photogrammetry:editor'
export const PERMISSION_CANTILEVER_PHOTOGRAMMETRY_ADMIN =
  'cantilever:photogrammetry:admin'

export const PERMISSION_CANTILEVER_EXTENSION_CONFIG_EDITOR =
  'cantilever:extension-configuration:editor'
export const PERMISSION_CANTILEVER_PROCESS_FLOW_EDITOR =
  'cantilever:process-flow:editor'
export const PERMISSION_CANTILEVER_PROCESS_FLOW_VIEWER =
  'cantilever:process-flow:viewer'
export const PERMISSION_CANTILEVER_PROCESS_FLOW_ADMIN =
  'cantilever:process-flow:admin'

// External user permissions
export type SiteEditPermission = `rolodex:site:${string}:edit`
export type SiteMemberPermission = `rolodex:site:${string}:member`
export type OrgMemberPermission = `rolodex:organization:${string}:member`
export function getSiteEditPermission(siteId: string): SiteEditPermission {
  return `rolodex:site:${siteId}:edit`
}
export function getSiteMemberPermission(siteId: string): SiteMemberPermission {
  return `rolodex:site:${siteId}:member`
}
export function getOrgMemberPermission(orgId: string): OrgMemberPermission {
  return `rolodex:organization:${orgId}:member`
}

export const geckoPerms = [
  PERMISSION_CANTILEVER_ACCESS_ADMIN,
  PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT,
  PERMISSION_CANTILEVER_CORE_EDIT,
  PERMISSION_GECKO_READ,
  PERMISSION_GECKO_INTERNAL_MEMBER,
]

export type RolodexPermissions =
  | typeof PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT
  | typeof PERMISSION_CANTILEVER_MARKUP_LAYER_EDIT
  | typeof PERMISSION_GECKO_READ
  | typeof PERMISSION_GECKO_INTERNAL_MEMBER
  | typeof PERMISSION_CANTILEVER_PUBLISHER_ARCHIVE_EDITOR
  | typeof PERMISSION_CANTILEVER_ACCESS_ADMIN
  | typeof PERMISSION_CANTILEVER_CORE_EDIT
  | typeof PERMISSION_CANTILEVER_CORE_ADMIN
  | typeof PERMISSION_CANTILEVER_ASSET_OVERVIEW_VIEWER
  | typeof PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR
  | typeof PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN
  | typeof PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_VIEWER
  | typeof PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_EDITOR
  | typeof PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_ADMIN
  | typeof PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_VIEWER
  | typeof PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_EDITOR
  | typeof PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_ADMIN
  | typeof PERMISSION_CANTILEVER_HEALTH_PLAN_EDITOR
  | typeof PERMISSION_CANTILEVER_HEALTH_PLAN_VIEWER
  | typeof PERMISSION_CANTILEVER_EXPLOERER_EDITOR
  | typeof PERMISSION_CANTILEVER_EXPLOERER_VIEWER
  | typeof PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_EDITOR
  | typeof PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_VIEWER
  | typeof PERMISSION_CANTILEVER_PARTS_THREAD_EDITOR
  | typeof PERMISSION_CANTILEVER_PARTS_THREAD_VIEWER
  | typeof PERMISSION_CANTILEVER_EXTENSION_CONFIG_EDITOR
  | typeof PERMISSION_CANTILEVER_PHOTOGRAMMETRY_EDITOR
  | typeof PERMISSION_CANTILEVER_PHOTOGRAMMETRY_ADMIN
  | SiteEditPermission
  | SiteMemberPermission
  | OrgMemberPermission
  | typeof PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN
  | typeof PERMISSION_CANTILEVER_PROCESS_FLOW_EDITOR
  | typeof PERMISSION_CANTILEVER_PROCESS_FLOW_VIEWER
  | typeof PERMISSION_CANTILEVER_PROCESS_FLOW_ADMIN
